'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function ETFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-bi4g7m4hd", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-bpbdupeqd", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-05wf5h1v3" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-05wf5h1v3", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-bi4g7m4hd)" }, /* @__PURE__ */ React.createElement("use", { fill: "#feca00", xlinkHref: "#mantine-05wf5h1v3" }), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 0h32v8H0z", mask: "url(#mantine-bpbdupeqd)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 16h32v8H0z", mask: "url(#mantine-bpbdupeqd)" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-bpbdupeqd)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(10 6)" }, /* @__PURE__ */ React.createElement("circle", { cx: "6", cy: "6", r: "6", fill: "#2b77b8" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        stroke: "#feca00",
        strokeWidth: "1.5",
        d: "M6 8l-2.762.927.86-2.309-1.874-2.236h2.6L6 2l1.176 2.382h2.657l-1.93 2.236.684 2.309z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        stroke: "#2b77b8",
        d: "M5.696 6.034l-2.085 4.36M5.368 5.48h-4m4.753 1.358l3.91 1.804M6.967 5.874l2.83-3.098"
      }
    )))))
  );
}

export { ETFlag };
//# sourceMappingURL=ET.mjs.map
